import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=812b49e0&scoped=true&"
import script from "./searchPage.vue?vue&type=script&lang=ts&"
export * from "./searchPage.vue?vue&type=script&lang=ts&"
import style0 from "./searchPage.vue?vue&type=style&index=0&id=812b49e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812b49e0",
  null
  
)

export default component.exports